import { AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Menu } from '../../core/model/menu';
import { ServiceConfig } from '../../core/model/service-config';
import { AuthenticationService } from '../../core/services/authentication.service';
import { MenuService } from '../../core/services/menu.service';
import { ServiceConfigService } from '../../core/services/service-config.service';
import { SessionService } from '../../core/services/session.service';


declare var $: any;

@Component({
    selector: 'app-mainmenu',
    templateUrl: './mainmenu.component.html',
    styleUrls: ['./mainmenu.component.css'],
    providers: [MenuService]
})
export class MainmenuComponent implements OnInit, OnDestroy, AfterViewChecked {


    // Propiedades del componente
    allMenus: Menu[];

    statusCode: number;
    requestProcessing = false;
    private subscription;
    private subscription_change;
    username: string;
    clientname: string;
    idcliente: number;
    configs: ServiceConfig[] = [];

    private hasInventorySearch = false;

    hasInitialData: boolean;

    private hasSelectChild = false;


    body: HTMLBodyElement = document.getElementsByTagName('body')[0];

    branch: string;
    hasChild = false;
    clientHasInitialDataEvent: Subscription;
    opacity = 1;

    constructor(private menuservice: MenuService,
        private translateService: TranslateService,
        private toastr: ToastrService,
        private authService: AuthenticationService,
        private serviceConfigService: ServiceConfigService,
        private router: Router,
        private cdRef: ChangeDetectorRef,
        private sessionService: SessionService
    ) { this.idcliente = 0; }

    ngOnInit() {
        // reinicia el menu tree cuando hay un reload back history
        // con los ultimos cambios ya no funciona (solo se abre no se cierra)
        /*$(document).ready(() => {
            const trees: any = $('[data-widget="tree"]');
            trees.tree();
        });*/

        this.authService.getUserName().subscribe(data => {
            this.username = data;
        });

        this.authService.getClienteName$().subscribe(data => {
            this.clientname = data;
        });

        this.idcliente = this.sessionService.getClientId();

        this.clientHasInitialDataEvent = this.authService.clientHasInitialData().subscribe(hasInitialData => {
            this.hasInitialData = hasInitialData;
            if (this.hasInitialData) {
                const config = this.serviceConfigService.getServiceConfig();

                this.hasInventorySearch = config.inventorySearch;
                this.configs = config.serviceConfigs;

                this.getMenu();
            } else {
                if (this.clientHasInitialDataEvent) {
                    this.clientHasInitialDataEvent.unsubscribe();
                }
                this.hasInventorySearch = false;
                this.configs = [];
            }
        });
    }

    ngAfterViewChecked() {
        this.cdRef.detectChanges();
    }

    getRouter(menu: Menu): string {
        if (this.hasChild) {
            return menu.NOMBRE;
        }
        const url = this.router.url.split('servicio/');
        if (url.length > 1) {
            const servicio = url[1].substring(0, url[1].length - 1);
            return servicio;
        }
        const inicio = url[0].indexOf(':');
        const final = url[0].indexOf(')');
        const contenido = url[0].substring(inicio + 1, final);
        return contenido;
    }

    private translateMenu(): void {
        this.subscription = this.translateService.get(['menus'])
            .subscribe(values => {
                this.allMenus.forEach((menuItem: Menu) => {
                    menuItem.NOMBRE = values['menus'][menuItem.ID_TIPO_MENU];
                    // check for childs
                    if (menuItem.SubMenu != null) {
                        menuItem.SubMenu.forEach((childItem: Menu) => {
                            childItem.NOMBRE = values['menus'][childItem.ID_TIPO_MENU];
                        });
                    }
                });
            });
    }

    getMenu() {
        this.preProcessConfigurations('Cargando menu');
        this.menuservice.getMenus()
            .subscribe(
                data => {
                    this.allMenus = new Array();
                    this.allMenus = data;
                    if (!this.hasInventorySearch) {
                        this.allMenus = this.allMenus.filter(menu => menu.ACTION != 'inventarios');
                    }

                    this.requestProcessing = false;

                    if (this.allMenus.length > 0) {
                        // this.translateMenu();
                        this.subscription_change = this.translateService.onLangChange.subscribe(() => {
                            // this.translateMenu();
                        });

                        this.selectMenuTab();
                    }
                    // this.toastr.info('Direcciones cargadas correctamente', 'Carga correcta');
                },
                errorCode => this.statusCode = errorCode);
    }

    private selectMenuTab() {
        const actionTab = this.getActionFromUrl();
        const menuSelected = this.allMenus.find(menu => menu.ACTION == actionTab);
        if (menuSelected) {
            this.branch = menuSelected.NOMBRE;
            if (menuSelected.SubMenu.length > 0) {
                const menuChildSelected = menuSelected.SubMenu.find(menu => menu.ACTION == actionTab);
                if (menuChildSelected) {
                    menuSelected.Collapse = false;
                    menuSelected.ChildBranchName = menuChildSelected.NOMBRE;
                }
            }
        }
    }

    private getActionFromUrl(): string {
        const url = this.router.url.split('servicio/');
        if (url.length > 1) {
            const servicio = url[1].substring(0, url[1].length - 1);
            return servicio;
        }
        const inicio = url[0].indexOf(':');
        const final = url[0].indexOf(')');
        return url[0].substring(inicio + 1, final);
    }

    preProcessConfigurations(mensaje: string) {
        this.statusCode = null;
        this.requestProcessing = true;
    }
    onSelect(nombre: string, hasSubmenu?: boolean) {
        if (this.branch !== nombre) {
            this.branch = nombre;
            this.hasChild = true;
            this.allMenus.map(menu => {
                menu.Collapse = true;
                if (!hasSubmenu) {
                    menu.ChildBranchName = '';
                }
            });
        }
    }

    selectChild(nombre: string, menu: Menu) {
        this.allMenus.map(men => men.ChildBranchName = '');
        menu.ChildBranchName = nombre;
        this.hasChild = false;
        this.hasSelectChild = true;
    }

    onHideMenu() {
        // for mobile
        this.body.classList.remove('sidebar-open');
        // for desktop
        this.body.classList.add('sidebar-collapse');
    }
    ngOnDestroy() {
        // console.log('Unsubscribe menu');

        if (this.subscription != null) {
            this.subscription.unsubscribe();
        }

        if (this.subscription_change != null) {
            this.subscription_change.unsubscribe();
        }
    }

    isAService(name: string): boolean {
        return name !== 'materiales' && this.configs.filter((config: ServiceConfig) => config.servicio === name).length > 0;
    }

    onSelectMenuWithSubMenu(opcion: Menu) {
        this.onSelect(opcion.NOMBRE, true);
        if (this.hasSelectChild) {
            this.hasSelectChild = false;
            return;
        }
        opcion.Collapse = !opcion.Collapse;
    }

    processMulticlientToggle(open: boolean) {
        if (open) {
            this.opacity = 0.3;
        } else {
            this.opacity = 1.0;
        }
    }
}
